import React, { Component } from 'react'
import axios from "axios";
import Navbar from "../../../Components/NavBar/Navbar";
import Sidebar from "../../../Components/Sidebar/sidebar";
import ResponsiveSidebar from "../../../Components/Sidebar/Responsive/SideBar";
import { SIDE_NAV_ITEMS } from "../../../api-constant";
import ManageWorksheet from "./Manage-Worksheet";
import ResponsiveManageWorksheet from "./Responsive/Manage-WorkSheet";

const calcWidth = window.innerWidth;

export class Manage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSideNav: SIDE_NAV_ITEMS[0].id,
            enableNotification: false,
            sidebarOpen: false,
            collapseID: null,
            sharedTo: [],
            AddModal: false,
        }
    }

    componentDidMount() {
        axios.get('http://api-uat.opptimise.in/api/v1/assessments/goal-setting/worksheets/shared_with/19/')
            .then((response) => {
                this.setState({
                    sharedTo: response.data
                })
            })
            .catch((error) => {
                console.error(error);
            });
    }

    onSetSidebarOpen = (open) => {
        this.setState({
            sidebarOpen: open,
        });
    };

    handleNotification = () => {
        this.setState({
          enableNotification: !this.state.enableNotification,
        });
      };
    

    toggleCollapse = (collapseID) => {
        if (this.state.collapseID === collapseID) {
          this.setState({
            collapseID: null,
          });
        } else {
          this.setState({
            collapseID: collapseID,
          });
        }
    };

    handleAddModal = () => {
        this.setState({
            AddModal: true
        })
    }

    handleModalClose = () => {
        this.setState({
            AddModal: false
        });
    };
    render() {
        return (
            <div>
                <Navbar
                    enableNotification={this.state.enableNotification}
                    handleNotification={this.handleNotification}
                />
                <ResponsiveSidebar
                    items={SIDE_NAV_ITEMS}
                    selectedSideNav={this.state.selectedSideNav}
                    sidebarOpen={this.state.sidebarOpen}
                    onSetSidebarOpen={this.onSetSidebarOpen}
                />
                <Sidebar
                    items={SIDE_NAV_ITEMS}
                    selectedSideNav={this.state.selectedSideNav}
                />

                {calcWidth <= 767 ? (
                    <ResponsiveManageWorksheet
                        AddModal={this.state.AddModal}
                    handleAddModal={this.handleAddModal}
                    handleModalClose={this.handleModalClose}
                        sharedTo={this.state.sharedTo}
                        collapseID={this.state.collapseID}
                        toggleCollapse={this.toggleCollapse}
                    />
                ): (
                    <ManageWorksheet
                    AddModal={this.state.AddModal}
                    handleAddModal={this.handleAddModal}
                    handleModalClose={this.handleModalClose}
                    sharedTo={this.state.sharedTo}
                />
                )}
            </div>
        )
    }
}

export default Manage



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Manage-WorkSheet/index.jsx